import ErrorLabel from '../../components/error';
import { useState } from "react";
import { useTranslation } from 'react-i18next';

export function InputField({
    name,
    id = null,
    readOnly = false,
    disabled = false,
    type = 'text',
    onChangeValue,
    onKeyDown,
    onKeyPress,
    title,
    errorLabel,
    placeholder,
    secondary = false,
    value,
    required = false,
    length = 50,
    extraClasses = '',
    labelStyle ='',
    passwordStrength = false,
    onAcceptPassword,
    refValue,
    language ,
    ...props
}) {
    let lang = localStorage.getItem("i18nextLng");
    const { t: trans } = useTranslation("info")
    const languageDir = "language-" + lang;
    const [validationMessage, setValidationMessage] = useState('');
    const [strength, setStrength] = useState(
        {
            weak: false,
            middle: false,
            powerful: false
        }
    );

    const handleInputChange = (event) => {
        if (event.target.validity.valid) {

            if (onChangeValue)
                onChangeValue(event);
            if (passwordStrength) {
                handlePasswordStrength(event);
            }

        } else {
            event.preventDefault();
            return false;
        }
    };
    // to handle the password strength 
    const handlePasswordStrength = (event) => {
        const _value = event.target.value;
        const _numericPattern = /[0-9]{3,}/g;
        const _alphaCapitalPattern = /[A-Z]{1,}/g
        const _alphaSamllPattern = /[a-z]{4,}/g;
        const _simplePattern = /[!@#\$%\^\&*\)\(+=._-]{1,}/g;
        try {
            const val = { ...strength };
            let strengthCount = 0;
            let _message = trans("info:password_accept_note");

            if (!_numericPattern.test(_value)) {
                _message += ' ' + trans("info:password_accept_num");
            } else if (!_alphaCapitalPattern.test(_value)) {
                _message += ' ' + trans("info:password_accept_capital_alph");
            } else if (!_alphaSamllPattern.test(_value)) {
                _message += ' ' + trans("info:password_accept_small_alph");
            } else if (!_simplePattern.test(_value)) {
                _message += ' ' + trans("info:password_accept_simple");
            } else {
                _message = '';
            }
            if (_value?.search(_numericPattern) != -1) {
                strengthCount += 1;
            }
            if (_value?.search(_alphaCapitalPattern) != -1) {
                strengthCount += 1;
            }
            if (_value?.search(_alphaSamllPattern) != -1) {
                strengthCount += 1;
            } if (_value?.search(_simplePattern) != -1) {
                strengthCount += 1;
            }
            switch (strengthCount) {
                case 1:
                    val.weak = true;
                    val.middle = false;
                    val.powerful = false;
                    break;
                case 2:
                    val.weak = true;
                    val.middle = true;
                    val.powerful = false;
                    break;
                case 3:
                    val.weak = true;
                    val.middle = true;
                    val.powerful = false;
                    break;
                case 4:
                    val.weak = true;
                    val.middle = true;
                    val.powerful = true;
                    break;
                default:
                    val.weak = false;
                    val.middle = false;
                    val.powerful = false;
            }
            setStrength(val);
            setValidationMessage(_message);
            if (onAcceptPassword) {
                if (val.weak && val.middle && val.powerful) {
                    onAcceptPassword(true);
                } else {
                    onAcceptPassword(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className={`input  ${language ? language :languageDir}  ${secondary && "input-secondary"}`}>

            {
                title &&
                <label className={`input-label ${labelStyle} `} htmlFor={name}>{title}</label>
            }

            <input disabled={disabled}
                {
                ...props
                }
                ref={refValue}
                onKeyDown={(event) => {
                    if (onKeyDown)
                        onKeyDown(event)
                }}
                onKeyPress={(event) => {
                    if (onKeyPress)
                        onKeyPress(event)
                }}
                id={id}
                name={name}
                maxLength={length}
                readOnly={readOnly}

                onInput={(e) => { handleInputChange(e) }}
                onChange={(e) => {
                    // if (onChangeValue)
                    //     onChangeValue(e);
                    // if (passwordStrength) {
                    //     handlePasswordStrength(e);
                    // }
                }}
                className={`input-field bg-theme-up  ${errorLabel && 'border-danger'}   ${extraClasses}`}
                placeholder={placeholder}
                required={required}
                type={type}
                value={value} />
            {(type == 'password' && passwordStrength) && <div className='nice-flex nice-flex-column'>
                <div className='nice-flex nice-flex-row my-2'>
                    <div className={`box-strength ${strength.weak && 'bg-danger'}`}></div>
                    <div className={`box-strength  ${strength.middle && 'bg-warning'}`}></div>
                    <div className={`box-strength  ${strength.powerful && 'bg-primary'}`}></div>
                </div>
                <p className='text-14 text-gray'>{validationMessage}</p>
            </div>
            }
        </div>
    );
}
